import { IonBadge, IonCardHeader, IonCardTitle } from "@ionic/react";
import React from "react";
import { calculateDiscount } from "../../../../../utils/calculateDiscount";
import { checkProductNew } from "../../../../../utils/checkProductNew";
import { Image } from "../../../../../components/Image/Image";
import { useConfig } from "../../../../../providers/config";
import { Product } from "@core/types";
import classNames from "classnames/bind";
import styles from "./MainPageProduct.module.scss";
import { useProductCardActions } from "../../../../../providers/useProductActions";
import { getPreviewImage } from "../../../../../utils/getPreviewImage";
import { useTranslation } from "react-i18next";


const cx = classNames.bind(styles);

const CardHeader = ({ product, lazyload }: { product: Product; lazyload: boolean }) => {
  const { t } = useTranslation();
  const config = useConfig();
  const { showProductDetail } = useProductCardActions();
  const productImage = getPreviewImage(product?.images[0]);

  const isProductNew = checkProductNew(product.dateCreated, config?.newProductDuration!);

  const handleShowProductDetail = () => {
    showProductDetail(product.id);
  };

  const discount = calculateDiscount(
    product.type,
    product.onSale,
    product.price,
    product.regularPrice,
    product.priceHtml
  );

  return (
    <>
      {isProductNew && <IonBadge className={cx("new-product-label")}>{t("NEW")}</IonBadge>}
      {discount && <IonBadge className={cx("new-product-label")}>{discount?.toFixed(0)}%</IonBadge>}

      <Image
        lazyLoad={lazyload}
        draggable={false}
        style={{ maxWidth: "100%", maxHeight: "91px", height: "91px" }}
        image={productImage}
        className={cx("cardFortimeImage")}
        onClick={handleShowProductDetail}
      />

      <IonCardHeader onClick={handleShowProductDetail} className={cx("cardFortimeHeader", "cursor-pointer")}>
        <IonCardTitle className={cx("cardFortimeHeaderTitle")}>{product.name}</IonCardTitle>
      </IonCardHeader>
    </>
  );
};

export default CardHeader;
